import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SearchEngineItem } from '../../models/api';
import { ContextService } from '../../services/ctx.service';
import { NavService } from '../../services/nav.service';
import { StateService } from '../../services/state.service';
import { AppState } from '../../models/state';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnDestroy {
  services: Partial<SearchEngineItem>[];
  state: Partial<AppState>;
  newCardArray: Array<Array<Partial<SearchEngineItem>>>;
  subs: Subscription;

  constructor(
    public route: Router,
    public nav: NavService,
    private stateService: StateService,
    private ctx: ContextService
  ) {
    this.newCardArray = [];
    this.subs = new Subscription();
    this.subs.add(
      this.stateService.getState().subscribe((state) => {
        this.state = state;
        this.services = state?.searchEngineList;
        const chunkSize = this.ctx.isDesktop ? 4 : 2;
        this.generateArray(chunkSize);
      })
    );
  }

  generateArray(chunkSize: number): void {
    this.newCardArray = [];
    for (let i = 0; i < this.services?.length; i += chunkSize) {
      const chunk = this.services.slice(i, i + chunkSize);
      this.newCardArray.push(chunk);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  navTo(url: string): void {
    this.state = {
      ...this.state,
      specialities: null,
      medicalGuides: null,
      searchParams: {},
      searchFilters: {},
      medicalCentersResponse: {}
    }
    this.stateService.updateState({ ...this.state });

    if (url) this.nav.navTo(url);
  }
}
